import { Row } from "@narmi/design_system";
import styles from "./style.module.css";
import { getContextualTimestamp } from "@utils/time";

export function ReadReceipt({ timestamp }: { timestamp: string }) {
  return (
    <div className="margin--y--s padding--right--s">
      <Row alignItems="center" gapSize="xs">
        <Row.Item>
          <div className={styles.separatorLine} />
        </Row.Item>
        <Row.Item shrink>
          <div className="fontSize--s fontColor--secondary">
            Seen at {getContextualTimestamp(timestamp)}
          </div>
        </Row.Item>
      </Row>
    </div>
  );
}
